import React from "react"

class ColorLegend extends React.Component {
  render() {
    return (
      <div className="color-key center">
        <div className="color-key-item">
          <div className="color-circle color-circle-in" />
          Marked &quot;In&quot;
        </div>
        <div className="color-key-item">
          <div className="color-circle color-circle-out" />
          Marked &quot;Out&quot;
        </div>
        <div className="color-key-item">
          <div className="color-circle color-circle-day-trip" />
          Day Trip
        </div>
        <div className="color-key-item">
          <div className="color-circle color-circle-conflict" />
          Conflict
        </div>
        <div className="color-key-item">
          <div className="color-circle color-circle-placeholder" />
          Placeholder
        </div>
      </div>
    )
  }
}

export default ColorLegend
